import React, { useMemo, useContext } from "react";
import { useIntl } from "react-intl";
import dynamic from "next/dynamic";
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
	AccordionContext,
} from "./Accordion";
import AccordionVariables from "../variables/variables.json";
import FAQStructuredData from "./FAQStructuredData";
import { useArticleMeta } from "./ArticleMetaContext";
import { getFaqItemsFromSection } from "../lib/faq";

const TranslatedMessageFAQ = dynamic(() => import("./TranslatedMessageFAQ"));

function FAQExample(props) {
	const intl = useIntl();
	const articleMeta = useArticleMeta();
	const propsMiasto = props.miasto || "PRZYJAZNEDEKLARACJE";
	const propsPodatek = props.section;

	const faqItems = useMemo(() => {
		const faqRoot = AccordionVariables.miasta?.[propsMiasto]?.FAQ;

		return getFaqItemsFromSection({
			faqRoot,
			section: propsPodatek,
			translate: (id) => intl.formatMessage({ id }),
		});
	}, [intl, propsMiasto, propsPodatek]);

	const allIndices = useMemo(() => {
		return faqItems.map((_, index) => index);
	}, [faqItems]);

	const AccordionButtonLabel = ({ itemIndex }) => {
		const { expandedIndices } = useContext(AccordionContext);
		return expandedIndices.includes(itemIndex) ? "Zwiń odpowiedź" : "Rozwiń odpowiedź";
	};

	if (!faqItems.length) {
		return null;
	}

	const articleOwnsFaqSchema = Array.isArray(articleMeta?.faqItems) && articleMeta.faqItems.length > 0;
	const shouldRenderSchema = props.schema !== false && !articleOwnsFaqSchema;

	return (
		<>
			{shouldRenderSchema && <FAQStructuredData items={faqItems} />}

			<Accordion
				className="accordion-template--secondary"
				allowMultipleExpanded={true}
				preExpanded={allIndices}
			>
				{faqItems.map((faq, index) => (
					<AccordionItem key={faq.key || `${propsPodatek}-${index}`}>
						<AccordionItemHeading>
							<h3 className="accordion__title" id={`heading-${propsPodatek}-${index}`}>
								{faq.question}
							</h3>

							<AccordionItemButton itemIndex={index}>
								<AccordionButtonLabel itemIndex={index} />
							</AccordionItemButton>
						</AccordionItemHeading>

						<AccordionItemPanel itemIndex={index}>
							<TranslatedMessageFAQ id={faq.answerId} />
						</AccordionItemPanel>
					</AccordionItem>
				))}
			</Accordion>
		</>
	);
}

export default FAQExample;
